/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getServerPages = async () => {
  const Components = {};
  if (ssr) {
    Components.room = (await import('./pages/room/RoomContainer')).RoomContainer;
    Components.bath = (await import('./pages/bath-renovation/BathRenovationContainer')).BathRenovationContainer;
    Components.orangeLens = (await import('./pages/orange-lens/OrangeLensContainer')).OrangeLensContainer;
    Components.browse = (await import('./pages/browse-search/BrowseAndSearchContainer')).BrowseAndSearchContainer;
    Components.browseMobile = (await import('./pages/browse-search/BrowseAndSearchMobileContainer')).BrowseAndSearchMobileContainer;
    Components.search = (await import('./pages/browse-search/BrowseAndSearchContainer')).BrowseAndSearchContainer;
    Components.searchMobile = (await import('./pages/browse-search/BrowseAndSearchMobileContainer')).BrowseAndSearchMobileContainer;
    Components.pep = (await import('./pages/pep/PepDesktopContainer')).PepDesktopContainer;
    Components.pepMobile = (await import('./pages/pep/PepMobileContainer')).PepMobileContainer;
    Components.paintReorder = (await import('./pages/paint-reorder/PaintReorderContainer')).PaintReorderContainer;
    Components.paintReorderMobile = (await import('./pages/paint-reorder/PaintReorderMobileContainer')).PaintReorderMobileContainer;
    Components.product = (await import('./pages/product/ProductContainer')).ProductContainer;
    Components.productMobile = (await import('./pages/product/ProductMobileContainer')).ProductMobileContainer;
    Components.collections = (await import('./pages/collections/CollectionsContainer')).CollectionsContainer;
    Components.collectionsMobile = (await import('./pages/collections/CollectionsContainerMobile')).CollectionsContainerMobile;
    Components.vendorCollections = (await import('./pages/vendor-collections/VendorCollectionsContainer')).VendorCollectionsContainer;
    Components.vendorCollectionsMobile = (await import('./pages/vendor-collections/VendorCollectionsContainerMobile')).VendorCollectionsContainerMobile;
    Components.compare = (await import('./pages/compare/CompareContainer')).CompareContainer;
    Components.styleQuiz = (await import('./pages/style-quiz/StyleQuizContainer')).StyleQuizContainer;
    Components.home = (await import('./pages/Home')).Home;
  }
  return Components;
};

export const getRoutes = (currentRouteName, currentRouteComponent, serverPages) => ({
  room: {
    name: 'RoomContainer',
    componentName: 'RoomContainer',
    chunk: () => import('./pages/room/RoomContainer'),
    get component() {
      return ssr
        ? serverPages.room
        : currentRouteName === 'RoomContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.RoomContainer }))
          );
    },
    path: '/:context?/room/:param1?/:param2?/:param3?',
    channel: null
  },
  bath: {
    name: 'BathRenovationContainer',
    componentName: 'BathRenovationContainer',
    chunk: () => import('./pages/bath-renovation/BathRenovationContainer'),
    get component() {
      return ssr
        ? serverPages.bath
        : currentRouteName === 'BathRenovationContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => {
            return this.chunk().then((pageModule) => ({ default: pageModule.BathRenovationContainer }));
          });
    },
    path: '/:context?/bath-renovation/:param1?/:param2?/:param3?',
    channel: null
  },
  orangeLens: {
    name: 'OrangeLensContainer',
    componentName: 'OrangeLensContainer',
    chunk: () => import('./pages/orange-lens/OrangeLensContainer'),
    get component() {
      return ssr
        ? serverPages.orangeLens
        : currentRouteName === 'OrangeLensContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => {
            return this.chunk().then((pageModule) => ({ default: pageModule.OrangeLensContainer }));
          });
    },
    path: '/:context?/orange-lens/:param1?/:param2?/:param3?',
    channel: null
  },
  browse: {
    name: 'BrowseAndSearchContainer',
    componentName: 'BrowseAndSearchContainer',
    chunk: () => import('./pages/browse-search/BrowseAndSearchContainer'),
    get component() {
      return ssr // eslint-disable-next-line max-len
        ? serverPages.browse
        : currentRouteName === 'BrowseAndSearchContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk()
            .then((pageModule) => ({ default: pageModule.BrowseAndSearchContainer }))
          );
    },
    path: '/:context?/:bassPV?/b/*',
    channel: 'desktop'
  },

  browseMobile: {
    name: 'BrowseAndSearchMobileContainer',
    componentName: 'BrowseAndSearchMobileContainer',
    chunk: () => import('./pages/browse-search/BrowseAndSearchMobileContainer'),
    get component() {
      return ssr
        ? serverPages.browseMobile
        : currentRouteName === 'BrowseAndSearchMobileContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({
            default: pageModule.BrowseAndSearchMobileContainer
          }))
          );
    },
    path: '/:context?/b/*',
    channel: 'mobile'
  },

  search: {
    name: 'BrowseAndSearchContainer',
    componentName: 'BrowseAndSearchContainer',
    chunk: () => import('./pages/browse-search/BrowseAndSearchContainer'),
    get component() {
      return ssr
        ? serverPages.search
        : currentRouteName === 'BrowseAndSearchContainer'
          ? currentRouteComponent // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.BrowseAndSearchContainer }))
          );
    },
    path: '/:context?/s/*',
    channel: 'desktop'
  },

  searchMobile: {
    name: 'BrowseAndSearchMobileContainer',
    componentName: 'BrowseAndSearchMobileContainer',
    chunk: () => import('./pages/browse-search/BrowseAndSearchMobileContainer'),
    get component() {
      return ssr
        ? serverPages.searchMobile
        : currentRouteName === 'BrowseAndSearchMobileContainer'
          ? currentRouteComponent // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({
            default: pageModule.BrowseAndSearchMobileContainer
          }))
          );
    },
    path: '/:context?/s/*',
    channel: 'mobile'
  },

  pep: {
    name: 'PepDesktopContainer',
    componentName: 'PepDesktopContainer',
    chunk: () => import('./pages/pep/PepDesktopContainer'),
    get component() {
      return ssr
        ? serverPages.pep
        : currentRouteName === 'PepDesktopContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.PepDesktopContainer }))
          );
    },
    path: '/:context?/pep/:slug?/:itemId',
    prefetch: ['product', 'compare'],
    channel: 'desktop'
  },

  // @TODO: Named export doesn't match the component file name.
  pepMobile: {
    name: 'PepMobileContainer',
    componentName: 'PepMobileContainer',
    chunk: () => import('./pages/pep/PepMobileContainer'),
    get component() {
      return ssr
        ? serverPages.pepMobile
        : currentRouteName === 'PepMobileContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.PepMobileContainer }))
          );
    },
    path: '/:context?/pep/:slug?/:itemId',
    prefetch: ['productMobile'],
    channel: 'mobile'
  },

  paintReorder: {
    name: 'PaintReorderContainer',
    componentName: 'PaintReorderContainer',
    chunk: () => import('./pages/paint-reorder/PaintReorderContainer'),
    get component() {
      return ssr
        ? serverPages.paintReorder
        : currentRouteName === 'PaintReorderContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk()
            .then((pageModule) => ({ default: pageModule.PaintReorderContainer })));
    },
    // p/paint/config/<configId>/<Brand>-<Size>-<Color-#>-<Sheen>/<BaseOMSID></BaseOMSID>
    path: '/:context?/p/paint/config/:configId/:slug?/:itemId',
    channel: 'desktop'
  },

  paintReorderMobile: {
    name: 'PaintReorderMobileContainer',
    componentName: 'PaintReorderMobileContainer',
    chunk: () => import('./pages/paint-reorder/PaintReorderMobileContainer'),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? serverPages.paintReorderMobile
        : currentRouteName === 'PaintReorderMobileContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk()
            .then((pageModule) => ({ default: pageModule.PaintReorderMobileContainer })));
    },
    path: '/:context?/p/paint/config/:configId/:slug?/:itemId',
    channel: 'mobile'
  },

  product: {
    name: 'ProductContainer',
    componentName: 'ProductContainer',
    chunk: () => import('./pages/product/ProductContainer'),
    get component() {
      return ssr
        ? serverPages.product
        : currentRouteName === 'ProductContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ProductContainer }))
          );
    },
    path: '/:context?/p/:slug?/:itemId',
    prefetch: ['browse'],
    channel: 'desktop'
  },

  productMobile: {
    name: 'ProductMobileContainer',
    componentName: 'ProductMobileContainer',
    chunk: () => import('./pages/product/ProductMobileContainer'),
    get component() {
      return ssr
        ? serverPages.productMobile
        : currentRouteName === 'ProductMobileContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ProductMobileContainer }))
          );
    },
    path: '/:context?/p/:slug?/:itemId',
    prefetch: ['browseMobile'],
    channel: 'mobile'
  },

  collections: {
    name: 'CollectionsContainer',
    componentName: 'CollectionsContainer',
    chunk: () => import('./pages/collections/CollectionsContainer'),
    get component() {
      return ssr
        ? serverPages.collections
        : currentRouteName === 'CollectionsContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.CollectionsContainer }))
          );
    },
    path: '/:context?/collection/:category/:slug/:collectionId',
    channel: 'desktop'
  },

  collectionsMobile: {
    name: 'CollectionsContainerMobile',
    componentName: 'CollectionsContainerMobile',
    chunk: () => import('./pages/collections/CollectionsContainerMobile'),
    get component() {
      return ssr
        ? serverPages.collectionsMobile
        : currentRouteName === 'CollectionsContainerMobile'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk()
            .then((pageModule) => ({ default: pageModule.CollectionsContainerMobile }))
          );
    },
    path: '/:context?/collection/:category/:slug/:collectionId',
    channel: 'mobile'
  },
  vendorCollections: {
    name: 'VendorCollectionsContainer',
    componentName: 'VendorCollectionsContainer',
    chunk: () => import('./pages/vendor-collections/VendorCollectionsContainer'),
    get component() {
      return ssr
        ? serverPages.vendorCollections
        : currentRouteName === 'VendorCollectionsContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk()
            .then((pageModule) => ({ default: pageModule.VendorCollectionsContainer }))
          );
    },
    path: '/:context?/collection/:category/:collectionName',
    channel: 'desktop'
  },

  vendorCollectionsMobile: {
    name: 'VendorCollectionsContainerMobile',
    componentName: 'VendorCollectionsContainerMobile',
    chunk: () => import('./pages/vendor-collections/VendorCollectionsContainerMobile'),
    get component() {
      return ssr
        ? serverPages.vendorCollectionsMobile
        : currentRouteName === 'VendorCollectionsContainerMobile'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({
            default: pageModule.VendorCollectionsContainerMobile
          }))
          );
    },
    path: '/:context?/collection/:category/:collectionName',
    channel: 'mobile'
  },

  compare: {
    name: 'CompareContainer',
    componentName: 'CompareContainer',
    chunk: () => import('./pages/compare/CompareContainer'),
    get component() {
      return ssr
        ? serverPages.compare
        : currentRouteName === 'CompareContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.CompareContainer }))
          );
    },
    path: '/:context?/compare',
    channel: null
  },

  styleQuiz: {
    name: 'StyleQuizContainer',
    componentName: 'StyleQuizContainer',
    chunk: () => import('./pages/style-quiz/StyleQuizContainer'),
    get component() {
      return ssr
        ? serverPages.styleQuiz
        : currentRouteName === 'StyleQuizContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.StyleQuizContainer }))
          );
    },
    path: '/:context?/stylequiz/:styleId?',
    channel: null
  },
  home: {
    name: 'Home',
    componentName: 'Home',
    chunk: () => import('./pages/Home'),
    get component() {
      return ssr
        ? serverPages.home
        : currentRouteName === 'Home'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Home }))
          );
    },
    path: '/:context?/',
    channel: null
  }
});
